<template>
  <header :class="['header', isScroll && 'menuActive']">
    <img
      class="logo"
      src="@/assets/images/YuliApp/main/nav_logo.png"
      alt=""
      @click="handleToIndex"
    />
    <div :class="['menu']">
      <div
        :style="`opacity:${0}`"
        v-for="(item, index) in menuList"
        :key="index"
        :class="['menu-item']"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="market"></div>
  </header>
</template>

<script>
export default {
  props: {
    activeBtn: {
      type: String,
      default: "",
    },
    isScroll: {
      type: Boolean,
      default: false,
    },
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    handleToIndex() {
      this.$emit("backTop");
    },
  
    handlToMarket() {
      window.open("https://presale.yuliverse.com/sales/PreSale");
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  background: linear-gradient(
    180deg,
    rgba(38, 34, 79, 0.5) 0%,
    rgba(25, 19, 112, 0) 100%
  );
  .logo {
    width: 200px;
    height: 36px;
    margin-right: 9%;
    .img {
      width: 165px;
    }
  }
  @media only screen and (max-width: 980px) {
    .logo {
      width: 115px;
      height: 25px;
    }
  }
  .menu {
    display: flex;
    color: #fff;

    text-align: center;
    &-item {
      color: #fff;
      text-decoration: none;
      max-width: 100px;
      height: 80px;
      line-height: 80px;
      font-size: 18px;
      font-weight: 400;
      padding: 0 25px;
    }
    &-item + &-item {
      margin-left: 30px;
    }
  }
  .market {
    font-size: 18px;
    width: 132px;
    height: 40px;
    line-height: 40px;
    border-radius: 25px;
    color: #fff;
    font-family: "Josefin Sans";
    border-radius: 42px;
    margin-left: 3.5%;
  }
}
.menuActive {
  background-color: #000;
}
</style>
